import React, { CSSProperties, FC, useMemo } from 'react';
import styles from './Spinner.scss';
import { SpinnerProps } from './types';

export const Spinner: FC<SpinnerProps> = ({
  color = '#fff'
}) => {
  const styleVariable = useMemo(
    () =>
      ({
        '--spinner-color': color
      }) as CSSProperties,
    [color]
  );

  return (
    <div className={styles.root} style={styleVariable}>
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  );
};
